export const SET_CHARTS_LIST = 'SET_CHARTS_LIST'
export const REFRESH_CHART_SUCCESS = 'REFRESH_CHART_SUCCESS'
export const REFRESH_CHART_ERROR = 'REFRESH_CHART_ERROR'

export const setChartsList = payload => ({
  type: SET_CHARTS_LIST,
  payload,
})
